module.exports = "<h1 mat-dialog-title>{{ title }}</h1>\n<mat-dialog-content>\n    <p class=\"text-center\">\n        {{ content }}\n    </p>\n</mat-dialog-content>\n<mat-dialog-actions>\n    <div class=\"btn-group\" aria-label=\"Basic example\">\n        <button type=\"button\" class=\"btn\" (click)=\"agree()\">{{ btnAgree }}</button>\n        <button type=\"button\" class=\"btn\" (click)=\"desagree()\">{{ btnDisagree}}</button>\n    </div>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/confirm/confirm.component.html
// module id = ./src/app/components/confirm/confirm.component.html
// module chunks = main